module.exports = __webpack_public_path__ + "media/images/city_img/o_1-5e2d8f865cd2494a8f16122bcbef3560.jpg";